export default __webpack_public_path__ + "assets/facebook-footer-preview.5624076d.png";